module.exports = __webpack_public_path__ + "img/landing-layout-phone.aa3834a5.png";